<template>
  <div
    :class="classes"
    class="rt-input-number"
    @mouseenter="inputHovering = true"
    @mouseleave="inputHovering = false"
  >
    <el-input-number
      ref="input"
      v-bind="$attrs"
      :value="currentValue"
      :max="max"
      :min="min"
      :controls="controls"
      :show-close="!!showClose"
      :disabled="disabled"
      :precision="precision"
      :placeholder="computedInputPlaceholder"
      @input="inputHandler"
      @change="changeHandler"
      @blur="blurHandler"
      @focus="handleFocus"
      @display-value-change="displayValueChangeHandler"
    >
      <slot
        v-if="!controls"
        slot="prefix"
        name="prefix"
      >
        <slot name="prefix" />
      </slot>
      <rt-icon
        v-if="_computedRecordIcon"
        slot="suffix"
        :color="SCSS_VARIABLES.COLOR_INFO"
        name="rt-base-record-lined"
        class="rt-xpc-input-suffix"
        @click="inputFocus"
      />
      <rt-icon
        v-if="showClose"
        slot="suffix"
        :name="computedIconName"
        :style="computedClearIconStyle"
        :color="SCSS_VARIABLES.COLOR_SECONDARY"
        class="rt-xpc-input-clearicon"
        @click="clear"
      />
    </el-input-number>
  </div>
</template>

<script>
import inputFocusMixins from './inputFocusMixins.js';
import ElInputNumber from 'vue-xpc/src/element-ui/packages/input-number';
import xpcConfig from 'vue-xpc/src/config';
import Placeholder from './placeholder.js';

export default {
  name: 'RtInputNumber',
  components: { ElInputNumber },
  mixins: [inputFocusMixins, Placeholder],
  inject: {
    elForm: {
      default: ''
    },
    rtFormItem: {
      default: ''
    }
  },
  props: {
    value: {
      type: [Number, String],
      default: undefined
    },
    datafieldname: String,
    size: {
      type: String,
      default: 'medium'
    },
    max: {
      type: Number,
      default: Infinity
    },
    min: {
      type: Number,
      default: -Infinity
    },
    controls: {
      type: Boolean,
      default: true
    },
    clearable: { type: Boolean, default: undefined },
    disabled: { type: Boolean, default: undefined },
    // 自定义清空按钮位置
    clearIconRight: {
      type: Number,
      default: 0
    },
    precision: {
      type: Number,
      validator (val) {
        return val >= 0 && val === parseInt(val, 10);
      }
    }
  },
  data () {
    return {
      currentValue: this.value,
      inputHovering: false,
      displayValue: null
    };
  },
  computed: {
    classes () {
      return `rt-input-${this.size}`;
    },
    /**
     * 右侧编辑按钮是否显示
     */
    _computedRecordIcon () {
      return (
        !this.controls &&
        this.showSuffixIcon &&
        !this.computedDisabled &&
        !this.showPassword &&
        !this.showWordCount &&
        !this.showWordLimit &&
        this._computedSuffixIcon
      );
    },
    computedClearable () {
      return this.clearable === undefined
        ? this.elForm &&
            this.elForm.$attrs &&
            this.elForm.$attrs['all-clearable']
        : this.clearable;
    },
    computedDisabled () {
      return this.disabled || (this.elForm || {}).disabled;
    },
    showClose () {
      this.getClearIconRight();
      return (
        !this.controls &&
        this.displayValue &&
        this.inputHovering &&
        !this.computedDisabled &&
        this.computedClearable
      );
    },
    computedClearIconStyle () {
      let style = {};
      if (!this.controls && this.computedClearable) {
        style['marginRight'] =
          this.clearIconRight ||
          xpcConfig.get('clearicon.clearIconRight') + 'px';
      }

      return style;
    },
    computedIconName () {
      return this.clearIconName || xpcConfig.get('clearicon.clearIconName');
    }
  },
  watch: {
    value: {
      handler (newValue) {
        if (newValue === undefined || newValue === null || newValue === '') {
          this.currentValue = undefined;
        } else {
          this.currentValue = newValue;
          if (
            this.elForm &&
            this.elForm.validateField &&
            this.rtFormItem &&
            this.rtFormItem.prop
          ) {
            this.elForm.validateField(this.rtFormItem.prop);
          }
        }
      },
      immediate: true
    }
  },
  mounted () {
    this.getClearIconRight();
  },
  methods: {
    getClearIconRight () {
      this.$nextTick(() => {
        if (this.computedClearable && !this.controls) {
          if (this.$refs.input && this.$refs.input.$el) {
            const input = this.$refs.input.$el.querySelector(
              'input.el-input__inner'
            );
            input.style.paddingRight = `${this.clearIconRight + 24}px`;
          }
        }
      });
    },
    inputHandler (val) {
      this.currentValue = val;
      if (val !== this.value) {
        this.$emitDebounce('input', val, null, this.datafieldname);
      }
    },
    changeHandler (val) {
      if (val !== this.value) {
        this.$emit('change', val, null, this.datafieldname);
      }
    },
    blurHandler () {
      this.$emit('blur', this.currentValue, null, this.datafieldname);
    },
    clear () {
      this.currentValue = undefined;
      this.$emit('input', this.currentValue, null, this.datafieldname);
      this.$emit('clear');
    },
    handleFocus (event) {
      this.$emit('focus', event);
    },
    displayValueChangeHandler (val) {
      this.displayValue = val;
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtInputNumber.vue?6fea093b